import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Button,
  Grid,
  Paper,
  TextField,
  Select,
  InputLabel,
} from '@material-ui/core';
import { MenuItem } from 'material-ui';
import EditJobModalContainer from '../EditJobModal/EditJobModalContainer';
import { FONTS, COLORS } from '../../constants';

const styles = {
  title: {
    marginLeft: '2rem',
  },
  root: {
    padding: '20px 15px',
    fontFamily: FONTS.PRIMARY,
    color: COLORS.GREY_DARKER,
    margin: '2rem',
  },
  editButton: {
    color: COLORS.WHITE,
    backgroundColor: COLORS.GREEN,
  },
};

const JobCard = props => {
  const {
    job,
    handleLeadJobUpdate,
    dispatchApiCallFailed,
    dispatchApiCallSuccess,
  } = props;
  const { id, dateCreated, customerDetail, status } = job;
  const [leadStatus, setLeadStatus] = useState(status.value);
  const [isOpen, setIsOpen] = useState(false);
  const STATUS_CODES = {
    'New - Action Required': 1,
    'Customer Contacted': 2,
    'Tender Successful': 3,
    'Not Progressing - Archive': 4,
  };

  const leadStatusOnChange = e => {
    const newValue = e.target.value;
    setLeadStatus(newValue);
    job.statusCode = STATUS_CODES[newValue];
    handleLeadJobUpdate(job);
  };

  const openEditModal = () => {
    setIsOpen(true);
  };

  return (
    <>
      <Paper style={styles.root}>
        <Grid
          container
          style={styles.resultsRow}
          justify="center"
          alignItems="center"
          spacing={0}
        >
          <Grid item xs={1}>
            <TextField
              label="ID: "
              value={id}
              disabled
              InputProps={{ disableUnderline: true }}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              label="Date Created"
              value={moment(dateCreated).format('DD-MM-YYYY')}
              disabled
              InputProps={{ disableUnderline: true }}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              label="Customer Name"
              value={`${customerDetail.firstName} ${customerDetail.lastName}`}
              disabled
              InputProps={{ disableUnderline: true }}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              label="Email"
              value={customerDetail.email}
              disabled
              InputProps={{ disableUnderline: true }}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              label="Phone"
              value={customerDetail.phoneNumber}
              disabled
              InputProps={{ disableUnderline: true }}
            />
          </Grid>
          <Grid item xs={2}>
            <InputLabel shrink id="status-label">
              Lead Status
            </InputLabel>
            <Select
              value={leadStatus}
              labelId="status-label"
              onChange={leadStatusOnChange}
            >
              <MenuItem value="New - Action Required">
                New - Action Required
              </MenuItem>
              <MenuItem value="Customer Contacted">Customer Contacted</MenuItem>
              <MenuItem value="Tender Successful">Tender Successful</MenuItem>
              <MenuItem value="Not Progressing - Archive">
                Not Progressing - Archive
              </MenuItem>
            </Select>
          </Grid>
          <Grid item xs={1}>
            <Button
              variant="contained"
              size="small"
              style={styles.editButton}
              onClick={openEditModal}
            >
              Edit
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <EditJobModalContainer
        job={job}
        handleLeadJobUpdate={handleLeadJobUpdate}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        dispatchApiCallFailed={dispatchApiCallFailed}
        dispatchApiCallSuccess={dispatchApiCallSuccess}
      />
    </>
  );
};

const BuilderJobs = props => {
  const {
    jobs,
    handleLeadJobUpdate,
    dispatchApiCallFailed,
    dispatchApiCallSuccess,
  } = props;

  return (
    <div className="builder-jobs" style={styles.jobTable}>
      <h3 style={styles.title}>Manage Jobs</h3>
      {!jobs || jobs.length === 0 ? (
        <h5 style={styles.title}>No jobs found</h5>
      ) : (
        <>
          {jobs.map(job => (
            <JobCard
              job={job}
              key={job.id}
              handleLeadJobUpdate={handleLeadJobUpdate}
              dispatchApiCallFailed={dispatchApiCallFailed}
              dispatchApiCallSuccess={dispatchApiCallSuccess}
            />
          ))}
        </>
      )}
    </div>
  );
};

const cardPropTypes = {
  job: {
    id: PropTypes.number,
    dateCreated: PropTypes.string,
    customerDetail: {
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
    },
    status: {
      code: PropTypes.string,
      value: PropTypes.string,
    },
  },
  dispatchApiCallFailed: PropTypes.func,
  dispatchApiCallSuccess: PropTypes.func,
  handleLeadJobUpdate: PropTypes.func,
};

const propTypes = {
  jobs: PropTypes.array,
  handleLeadJobUpdate: PropTypes.func,
  dispatchApiCallFailed: PropTypes.func,
  dispatchApiCallSuccess: PropTypes.func,
};

JobCard.propTypes = cardPropTypes;
BuilderJobs.propTypes = propTypes;

export default BuilderJobs;
